module.exports = __webpack_public_path__ + "media/images/brand-square-41c9d44eaa4441277d3003f9bb670561.png";